import React from "react";
import { Card, Col, Row, Tag, Typography } from "antd";

const AnalyticsCard = props => {
  const { label, value, icon, type, cost = false, percentage = 0, loading } = props;
  return (
    <Card bordered className="rounded" hoverable loading={loading}>
      <Row gutter={20} type="flex" align="middle">
        <Col span={24}>
          <Row>
            <Col span={24}>
              <Typography.Text strong className="text-uppercase text-muted">
                <Typography.Text className={`me-2 ${type == "sent" ? "text-success-color" : type == "coin" ? "text-warning" : "text-info-color"}`}>{icon}</Typography.Text>
                {label}
              </Typography.Text>
            </Col>
            <Col span={24}>
              <Typography.Title className="fw-bold" level={4}>
                {cost && "AUD"} {value}
              </Typography.Title>
            </Col>
            <Col span={24}>
              <Typography.Paragraph ellipsis className="m-0">
                <Tag color={percentage > 0 ? "green" : percentage == 0 ? "cyan" : "red"}>
                  {percentage > 0 ? "+" : ""}
                  {percentage.toFixed(2)}%
                </Tag>{" "}
                From previous month
              </Typography.Paragraph>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default AnalyticsCard;
